import React from 'react';

// Global navigation bridge so non-component code (e.g. MobX stores) can navigate.
// This replaces mobx-react-router's RouterStore.

let navigateImpl = null;

export function setNavigate(fn) {
  navigateImpl = fn;
}

export function navigate(to, options) {
  if (!navigateImpl) {
    // No-op if called before router is mounted.
    return;
  }
  navigateImpl(to, options);
}

export function push(to) {
  navigate(to);
}

export function replace(to) {
  navigate(to, { replace: true });
}

export function NavigationHandler({ children }) {
  return <>{children}</>;
}
